export const GET_MANAGERS = "GET_MANAGERS";
export const GET_ALL_MANAGERS = "GET_ALL_MANAGERS";
export const EMPTY_MANAGERS = "EMPTY_MANAGERS";
